import { Injectable } from '@angular/core';
import * as Papa from 'papaparse';
import { Subject } from 'rxjs';
import { DateTimeService } from '../date-time.service';
import { environment } from '../../../environments/environment';

export interface Chart {
  Date: string;
  Open: number;
  High: number;
  Low: number;
  Close: number;
  AdjClose: number;
  Volume: number;
}

@Injectable({
  providedIn: 'root'
})
export class ChartService {
  PROXY_HERO = environment.proxy_herokuapp;
  // PROXY_ALL_ORIGINS = environment.proxy_all_origins;
  PROXY_ALL_ORIGINS = 'https://api.allorigins.win/raw?url=';
  CORS_MODE: RequestMode = environment.cors_mode as RequestMode;
  chartSubject$ = new Subject();
  symbol;

  constructor(
    private dtService: DateTimeService) { }

  getChart(period: string, symb?: string) {
    this.chartSubject$.next('clear');
    this.symbol = symb || this.symbol;
    const periodName = period.split(' ')[1]; // years, months, weeks
    const periodNum = period.split(' ')[0];
    const ago = this.dtService.getTimestampPeriodAgo(periodName, +periodNum);
    const now = this.dtService.getCurrentTimestampSecs();
    const path = `https://query1.finance.yahoo.com/v7/finance/download/${this.symbol}?period1=${ago}&period2=${now}&interval=1d&events=history`;
    // tslint:disable-next-line: max-line-length
    // const path = `https://query2.finance.yahoo.com/v8/finance/chart/${this.symbol}?symbol=${this.symbol}?period1=${ago}&period2=${now}&interval=5m`;

    const headers = { 'Access-Control-Allow-Origin': '*' };
    const fetchData = url => {
      return new Promise<Chart[]>((res, err) => {
        fetch(url, { headers })
          .then((response) => {
            return response.text();
          })
          .then(data => {
            // console.log('data:', data);
            const parsed = Papa.parse(data);
            // console.log('parsed:', parsed);
            return parsed;
          })
          .then(result => {
            this.chartSubject$.next(result.data.slice(1));
          });
      });
    };
    const promise = fetchData(this.PROXY_HERO + path)
      // const promise = fetchData(path)
      .then(res => console.log('promise res: ', res));

  }
}
